import { render, staticRenderFns } from "./PuzzleButtons.vue?vue&type=template&id=31d6d100&lang=html&"
import script from "./PuzzleButtons.vue?vue&type=script&lang=js&"
export * from "./PuzzleButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports